import CitySEOHead from "@/components/feature/CitySEOHead";
import MapleGroveHeroSection from "./components/HeroSection";
import MapleGroveStickyNav from "./components/StickyNav";
import MapleGroveProcessingTimeSection from "./components/ProcessingTimeSection";
import MapleGroveServicesSection from "./components/ServicesSection";
import MapleGroveLocalAreaSection from "./components/LocalAreaSection";
import MapleGroveTravelTimingSection from "./components/TravelTimingSection";
import MapleGroveDestinationsSection from "./components/DestinationsSection";
import MapleGroveTestimonialsSection from "./components/TestimonialsSection";
import MapleGroveAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import MapleGroveComparisonSection from "./components/ComparisonSection";
import MapleGroveMistakesSection from "./components/MistakesSection";
import MapleGroveHowItWorksSection from "./components/HowItWorksSection";
import MapleGroveFAQSection from "./components/FAQSection";
import MapleGroveHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import MapleGroveFinalCTA from "./components/FinalCTA";
import { faqs } from "./components/FAQSection";

export default function MapleGrovePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Maple Grove"
        state="Minnesota"
        stateAbbr="MN"
        route="/cities/maple-grove"
        title="Emergency Passport Maple Grove, MN — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Maple Grove, MN — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Arbor Lakes professionals, northwest metro families, and all of Hennepin County."
        keywords="expedited passport Maple Grove MN, emergency passport Maple Grove, passport renewal Hennepin County"
        geoPlacename="Maple Grove, Minnesota"
        geoPosition="45.0725;-93.4558"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Minnesota"
        statePageRoute="/states/minnesota"
      />
      <MapleGroveHeroSection />
      <MapleGroveStickyNav />
      <MapleGroveProcessingTimeSection />
      <MapleGroveLocalAreaSection />
      <MapleGroveServicesSection />
      <MapleGroveTravelTimingSection />
      <MapleGroveDestinationsSection />
      <MapleGroveTestimonialsSection />
      <MapleGroveAcceptanceFacilitiesSection />
      <MapleGroveComparisonSection />
      <MapleGroveMistakesSection />
      <MapleGroveHowItWorksSection />
      <MapleGroveFAQSection />
      <MapleGroveHelpfulResourcesSection />
      <MapleGroveFinalCTA />
    </div>
  );
}